import { BffUrls } from '@ansys-internal/portal-bff-angular-client';
import { AuthEnvironment } from '@ansys-internal/awf-angular/auth';
import baseEnvironment from '../../environment.json';
import { EnvironmentType } from './environment.enum';

export const environment = {
  production: true,
  type: AuthEnvironment.TEST,
  appStage: EnvironmentType.DEV,
  bff: BffUrls.DEV,
  msalClientId: baseEnvironment.devolopment.msalClientId,
  title: 'ConceptEV',
  apiURL: baseEnvironment.devolopment.apiURL,
  appURL: baseEnvironment.devolopment.appURL,
  ocmUrl: 'https://solve.test.portal.onscale.com/api',
  msalb2c: baseEnvironment.devolopment.msalb2c,
  msalAuthDomain: baseEnvironment.devolopment.msalAuthDomain,
  msalPortalScope: baseEnvironment.devolopment.msalPortalScope
};
